"use strict";
exports.__esModule = true;
exports.SocialLinkTypes = exports.FooterLinkTypes = void 0;
var FooterLinkTypes;
(function (FooterLinkTypes) {
    FooterLinkTypes["FOOTER_LINK"] = "footerLink";
    FooterLinkTypes["RGPD_LINK"] = "rgpdLink";
})(FooterLinkTypes = exports.FooterLinkTypes || (exports.FooterLinkTypes = {}));
var SocialLinkTypes;
(function (SocialLinkTypes) {
    SocialLinkTypes["FACEBOOK"] = "Facebook";
    SocialLinkTypes["INSTAGRAM"] = "Instagram";
    SocialLinkTypes["LINKEDIN"] = "LinkedIn";
    SocialLinkTypes["TWITTER"] = "Twitter";
    SocialLinkTypes["YOUTUBE"] = "Youtube";
})(SocialLinkTypes = exports.SocialLinkTypes || (exports.SocialLinkTypes = {}));
//# sourceMappingURL=footer.js.map